"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableHeadColumn = exports.EditableHeadColumnContainer = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalCss_1 = require("../../globalCss");
exports.EditableHeadColumnContainer = styled_components_1.default.div.attrs({
    className: 'tws-editable-headcolumn',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: table-cell;\n\tborder: 1px solid #999999;\n\tpadding: 10px;\n\toutline: none;\n\tvertical-align: middle;\n\theight: 40px;\n\t", "\n\t", "\n"], ["\n\tdisplay: table-cell;\n\tborder: 1px solid #999999;\n\tpadding: 10px;\n\toutline: none;\n\tvertical-align: middle;\n\theight: 40px;\n\t", "\n\t", "\n"])), globalCss_1.cappedHeaderMedium, function (props) { return (props.minWidth ? "min-width: ".concat(props.minWidth, ";") : ''); });
exports.EditableHeadColumnContainer.displayName = 'EditableHeadColumnContainer';
var EditableHeadColumn = /** @class */ (function (_super) {
    __extends(EditableHeadColumn, _super);
    function EditableHeadColumn(props) {
        return _super.call(this, props) || this;
    }
    EditableHeadColumn.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement(exports.EditableHeadColumnContainer, __assign({ editable: this.props.editable, editMode: this.props.editMode }, this.props, { tabIndex: 1 }), children));
    };
    return EditableHeadColumn;
}(React.Component));
exports.EditableHeadColumn = EditableHeadColumn;
var templateObject_1;
